// extracted by mini-css-extract-plugin
export default {"betkoShopLayout":"BetkoShopLayout_betkoShopLayout__GCZN7"};